import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

/**
 * The first full day MCP logs carry user ids. Before it, MCP calls were logged
 * as public API requests with no token id, then as MCP calls with no user.
 */
export const DEVELOPER_PLATFORM_ADOPTION_MIN_DATE = "2026-11-01";

/** Each day in range scans about 600k rows on top of the 29-day lookback. */
export const DEVELOPER_PLATFORM_ADOPTION_MAX_RANGE_DAYS = 90;

export const getDeveloperPlatformAdoption = {
  name: "getDeveloperPlatformAdoption" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    /**
     * One row per day and surface with activity in its trailing 30 days. Counts
     * are distinct over the trailing 1, 7 and 30 days ending on `date`, in UTC.
     * Users are MCP signed-in users and public API tokens; webhooks and
     * functions have no user, so theirs are zero.
     */
    rows: z.array(
      z.object({
        date: isoDate,
        surface: z.enum(["mcp", "public_api", "webhooks", "functions"]),
        dailyTeams: z.number(),
        weeklyTeams: z.number(),
        monthlyTeams: z.number(),
        dailyUsers: z.number(),
        weeklyUsers: z.number(),
        monthlyUsers: z.number(),
      }),
    ),
  }),
};
